import { render } from "./BacklogRail.vue?vue&type=template&id=124bc3e5&scoped=true"
import script from "./BacklogRail.vue?vue&type=script&lang=js"
export * from "./BacklogRail.vue?vue&type=script&lang=js"

import "./BacklogRail.vue?vue&type=style&index=0&id=124bc3e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-124bc3e5"]])

export default __exports__